export const postTypes = {
  status: "Estado",
  pull: "Pull",
  trade_completed: "Trade",
  trade_completed_auto: "Trade",
  wanted_card: "Buscada",
  collection_update: "Binder",
  store_post: "Tienda",
  community_event: "Evento",
  community_meetup: "Juntada",
  tournament_round: "Ronda",
  tournament_result: "Resultado",
  achievement: "Logro"
};

export const postTypeClass = type => {
  if (type === "pull") return "is-pull";
  if (type?.startsWith("trade")) return "is-trade";
  if (type === "wanted_card") return "is-wanted";
  if (type === "collection_update") return "is-binder";
  if (type === "achievement") return "is-achievement";
  if (type === "store_post") return "is-store";
  if (type?.startsWith("tournament") || type === "community_event" || type === "community_meetup") return "is-event";
  return "is-status";
};
